// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
var define;
var is_node = typeof module=='object' && module.exports;
if (is_node)
    define = require('../../../../util/require_node.js').define(module, '..');
else
    define = self.define;
define([], ()=>{
const E = {};
E.intro = [['div',
    [['h1',
        [`JS Coding Convention`],
        {className: `title`},
    ],
    ['p',
        [['b',
            [`Improvements? Suggestions?`],
        ],
        ` email `,
        ['a',
            [`dna@hola.org`],
            {href: `mailto:dna@hola.org`},
        ],
        ` `],
    ],
    ['p',
        [` Coding conventions used by other companies: `,
        ['a',
            [`AirBNB`],
            {href: `https://github.com/airbnb/javascript`},
        ],
        ` | `,
        ['a',
            [`google`],
            {href: `https://google.github.io/styleguide/javascriptguide.xml`},
        ],
        ` | `,
        ['a',
            [`crockford`],
            {href: `http://javascript.crockford.com/code.html`},
        ],
        ` | `,
        ['a',
            [`wordpress`],
            {href: `https://make.wordpress.org/core/handbook/best-practices/coding-standards/javascript/`},
        ],
        ` | `,
        ['a',
            [`drupal`],
            {href: `https://www.drupal.org/node/172169`},
        ],
        ` | `,
        ['a',
            [`weflex`],
            {href: `https://github.com/weflex/javascript`},
        ],
        ` `],
    ]],
    {className: `head`},
]];
E.data = [
    {
        id: 'overview',
        title: `Overview: consistent & minimal`,
        tag: 'h2',
        short: `Overview`,
        html: [],
    },
    {
        id: 'overview-consistent',
        title: `Be consistent`,
        tag: 'h3',
        short: `Be consistent`,
        html: [['p',
            [` If there is no specific rule in this document - `,
            ['a',
                [`be consistent with existing codebase`],
                {href: `/dna#dna-consistent`},
            ],
            ` (use `,
            ['a',
                [`rgrep`],
                {href: `/dna/dict#rgrep`},
            ],
            `).`,
            ['br'],
            ` If you're editing code, take a few minutes to look at the code
                around you and determine its style.`,
            ['br'],
            ` If it prints error messages starting with a capital letter,
                you should too. If it put spaces around complex expressions
                but not around simple expressions, your complex expressions
                should also have spaces around them.`,
            ['br'],
            ` The point of having style guidelines is to have a common
                vocabulary of coding, so people can concentrate on what
                you're saying rather than on how you're saying it.`,
            ['br'],
            ` If code you add to a file looks drastically different from the
                existing code around it, it throws readers out of their
                rhythm when they go to read it.`,
            ['br'],
            ` Avoid this. `],
        ]],
    },
    {
        id: 'overview-minimal',
        title: `Minimalistic and Condense`,
        tag: 'h3',
        short: `Minimalistic`,
        html: [['p',
            [` Wherever there is no specific rule, `,
            ['a',
                [`always prefer minimalism`],
                {href: `/dna#effective-minimal`},
            ],
            `.`,
            ['br'],
            ` Less tokens, higher condensity: get as much code as possible
                visible within the screen, so less scrolling is needed.`,
            ['br'],
            ` Sparse, elaborate, defensive code is not appreciated.`,
            ['br'],
            ['a',
                [`An example of absurd over-engineering`],
                {href: `https://chaosinmotion.blog/2011/01/25/how-not-to-write-factorial-in-java`},
            ],
            `. Although it's for Java, but the general idea holds for JS. `],
        ]],
    },
    {
        id: 'overview-tool',
        title: `Tools`,
        tag: 'h3',
        short: `Tools`,
        html: [['p',
            [` We write code by hand, line-by-line. We do have tools to
                assist us locating conventions mistakes `,
            ['code',
                [`zlint -c`],
            ],
            `, but they are just a 'helpers'.`,
            ['br'],
            ` The tools match our conventions only `,
            ['b',
                [`95%`],
            ],
            `, so its still our personal responsibility to manually make
                sure line-by-line the code we write matches the conventions
                `,
            ['b',
                [`100%`],
            ],
            `, whether the tool finds the mistakes or not. `],
        ]],
    },
    {
        id: 'overview-text_layout',
        title: `Text file layout`,
        tag: 'h3',
        short: `Text file layout`,
        html: [['p',
            [` Tab size is 8 spaces.`,
            ['br'],
            ` Shift width (indentation) is 4 spaces.`,
            ['br'],
            ` Column width 79 char, so it fits well with 80 col terminal.`,
            ['br'],
            ` Indentation is always one shift-width(4):`,
            ['br']],
        ],
        ['pre',
            [`open_msg_box("closing file %s on server\\n",
             file_name);
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`open_msg_box("closing file %s on server\\n",
    file_name);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format',
        title: `Formatting and naming`,
        tag: 'h2',
        short: `Formatting and naming`,
        html: [],
    },
    {
        id: 'format-block',
        title: `
  Code blocks and statements`,
        tag: 'h3',
        short: `Code blocks and statements`,
        html: [['ul',
            [['li',
                [['code',
                    [`if`],
                ],
                ['code',
                    [`for`],
                ],
                ['code',
                    [`while`],
                ],
                ` don't require a code block for 0 or 1 statements: open `,
                ['code',
                    [`{`],
                ],
                ` on next line. only use a block for multiline blocks. `],
            ],
            ['li',
                [['code',
                    [`try`],
                ],
                ['code',
                    [`catch`],
                ],
                ['code',
                    [`function`],
                ],
                ` require a code block in all cases: open `,
                ['code',
                    [`{`],
                ],
                ` on the same line. `],
            ]],
        ]],
    },
    {
        id: 'format-block-if_for_while',
        title: `
  if/for/while`,
        tag: 'h4',
        short: `if/for/while`,
        html: [],
    },
    {
        id: 'format-block-if_for_while-block',
        title: `
  if/for/while block`,
        tag: 'h5',
        short: `block`,
        html: [['p',
            [['code',
                [`if`],
            ],
            ['code',
                [`for`],
            ],
            ['code',
                [`while`],
            ],
            ` open and close braces of a section should be on the same
                level.`],
        ],
        ['pre',
            [`if (pkt) {
    pkt.close();
    pkt.uninit();
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (pkt)
{
    pkt.close();
    pkt.uninit();
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [['code',
                [`if`],
            ],
            ['code',
                [`for`],
            ],
            ['code',
                [`while`],
            ],
            ` statement that takes more than one line should always have
                braces`,
            ['br'],
            ` same thing goes when the then/loop part is more than one line
                `],
        ],
        ['pre',
            [`if (slot.dw_bus==pci_scan.card_slot[ret].dw_bus &&
    slot.dw_slot==pci_scan.card_slot[ret].dw_slot &&
    slot.dw_function==pci_scan.card_slot[ret].dw_function)
{
    break;
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (x==y)
{
    my_func(param1, param2, param3, param4, param5, param6,
        param7);
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`for (ret=0; ret<pci_scan.dw_cards; ret++)
    if (slot.dw_bus==pci_scan.card_slot[ret].dw_bus &&
        slot.dw_slot==pci_scan.card_slot[ret].dw_slot &&
        slot.dw_function==pci_scan.card_slot[ret].dw_function)
        break;
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`for (ret=0; ret<pci_scan.dw_cards; ret++)
{
    if (slot.dw_bus==pci_scan.card_slot[ret].dw_bus &&
        slot.dw_slot==pci_scan.card_slot[ret].dw_slot &&
        slot.dw_function==pci_scan.card_slot[ret].dw_function)
    {
        break;
    }
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-if_for_while-no_statement',
        title: `
  if/for/while without a statement
`,
        tag: 'h5',
        short: `if/for/while without a statement`,
        html: [['pre',
            [`while(pop_first(list))
    ;
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`while (pop_first(list));
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`for(i=0; i<10; i++)
    ;
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`for (i=0; i<10; i++);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (a>b+10)
    ;
else if (a>b+5)
    do_x();
else if (a>b+2)
    ;
else
    do_y();
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (a>b+10);
else if (a>b+5)
    do_x();
else if (a>b+2);
else
    do_y();
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-block-then',
        title: `Then`,
        tag: 'h5',
        short: `Then`,
        html: [['p',
            [` 'then' part of `,
            ['code',
                [`if`],
            ],
            ` statement should be in a separate line. `],
        ],
        ['pre',
            [`if (close_file) fclose(fp);
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (close_file)
    fclose(fp);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-block-else_if',
        title: `else if`,
        tag: 'h5',
        short: `else if`,
        html: [['p',
            [['code',
                [`else if`],
            ],
            ` statements should be on the same level at the starting `,
            ['code',
                [`if`],
            ],
            ` reason: this is similar to `,
            ['code',
                [`switch`],
            ],
            ` statement `],
        ],
        ['pre',
            [`if (argv[1]==="--help") print_usage();
else if (argv[1]==="--run") {
    run_application();
    print_results();
} else print_error();
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (argv[1]==="--help")
    print_usage();
else if (argv[1]==="--run")
{
    run_application();
    print_results();
}
else
    print_error();
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-block-func',
        title: `Functions`,
        tag: 'h4',
        short: `Functions`,
        html: [['p',
            [` Tiny functions: same line.`,
            ['br'],
            ` One-liner: body in second line.`,
            ['br'],
            ` Two lines and above: a proper block. if anon `,
            ['code',
                [`function`],
            ],
            `: block open in same line.`,
            ['br']],
        ],
        ['pre',
            [`var tiny = function(){code;};
var tiny = function() { code; };
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var tiny = function(){ code; };
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var tiny = function()
{
    code;
};
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var tiny = function(){
    code; };
var tiny = function(){
    code;
};
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`function tiny(){code;};
function tiny() { code; };
function tiny()
{
    code;
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`function tiny(){ code; }
function tiny(){
    code; }
function tiny(){
    code;
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`function long(args){
    code;
    code; }
function long(args)
{
    code;
    code;
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`function long(args){
    code;
    code;
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`function long_args(a1, a2, a3,
    a4){
    code;
    code;
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`function long_args(a1, a2, a3,
    a4)
{
    code;
    code;
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-block-func-inline',
        title: `Inline functions`,
        tag: 'h5',
        short: `Inline functions`,
        html: [['p',
            [`Function definition that fits the line:`],
        ],
        ['pre',
            [`let x = parse_args(...args, function(line){
    let escaped = E.escape(line);
    ...
});
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Function definition that does not fit the line:`],
        ],
        ['pre',
            [`let x = parse_args(a, b, c, d, e,
function(line, err)
{
    let escaped = E.escape(line);
    ...
});
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`let x = parse_args(a, b, c, d, e, function(line,
    err)
{
    let escaped = E.escape(line);
    ...
});
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`let x = parse_args(a, b, c, d, e,
    function(line, err){
        let escaped = E.escape(line);
        ...
    });
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`let x = parse_args(a, b, c, d, e,
    function(line, err)
{
    let escaped = E.escape(line);
    ...
});
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-block-func-spacing',
        title: `Functions spacing`,
        tag: 'h5',
        short: `Functions spacing`,
        html: [['p',
            [` No space between function name and opening parenthesis`,
            ['br'],
            ` No space between opening parenthesis and first parameter`,
            ['br'],
            ` One space after comma: `],
        ],
        ['pre',
            [`printf ("hello %s\\n", "world");
printf( "hello world\\n" );
printf("hello world\\n","world");
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`printf("hello %s\\n", "world");
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-block-break_line',
        title: `Breaking a long line`,
        tag: 'h4',
        short: `Breaking a long line`,
        html: [['p',
            [`When breaking up a long line, it should continue with one
                shift-width for indentation`],
        ],
        ['pre',
            [`if (line_length>1 && (screen.sz.vertical<buffer.sz.vertical
                      || explicit_lines))
{
    console.log("this is a test section that will show how to handle "+
                "long lines, such as this one which is 2 lines long");
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (line_length>1 && (screen.sz.vertical<buffer.sz.vertical
    || explicit_lines))
{
    console.log('this is a test section that will show how to handle '+
        'long lines, such as this one which is 2 lines long');
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-block-switch',
        title: `
  switch statements`,
        tag: 'h4',
        short: `Switch statement`,
        html: [['p',
            [['code',
                [`switch`],
            ],
            ` statements should have `,
            ['code',
                [`case`],
            ],
            ` on the same level, no space before `,
            ['code',
                [`:`],
            ],
            `.`,
            ['br']],
        ],
        ['pre',
            [`switch (key)
{
    case KEY_UP :
        key = UP;
        break;
    case KEY_DOWN :
        key = DN;
        break;
    default :
        key = NONE;
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`switch (key)
{
case KEY_UP:
    key = UP;
    break;
case KEY_DOWN:
    key = DN;
    break;
default:
    key = NONE;
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`switch (key)
{
case KEY_UP: key = UP; break;
case KEY_DOWN: key = DN; break;
default: key = NONE;
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [` 1-liner `,
            ['code',
                [`case`],
            ],
            `: with single statement plus `,
            ['code',
                [`break`],
            ],
            `, or a `,
            ['code',
                [`return`],
            ],
            ` statement. `],
        ],
        ['pre',
            [`switch (key)
{
case KEY_UP:
    line--;
    break;
case KEY_DOWN:
    for (x=line; x; x--)
        line++;
    break;
case KEY_ESC:
    return;
default:
    bubble = true;
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`switch (key)
{
case KEY_UP: line--; break;
case KEY_DOWN:
    for (x=line; x; x--)
        line++;
    break;
case KEY_ESC: return;
default: bubble = true;
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Never `,
            ['code',
                [`break`],
            ],
            ` after `,
            ['code',
                [`return`],
            ]],
        ],
        ['pre',
            [`switch (key)
{
case KEY_UP: line--; break;
case KEY_ESC: return; break;
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`switch (key)
{
case KEY_UP: line--; break;
case KEY_ESC: return;
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Never `,
            ['code',
                [`break`],
            ],
            ` at end of `,
            ['code',
                [`default`],
            ]],
        ],
        ['pre',
            [`switch (key)
{
case KEY_UP: line--; break;
default: line++; break;
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`switch (key)
{
case KEY_UP: line--; break;
default: line++;
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-block-reserved',
        title: `Reserved words`,
        tag: 'h4',
        short: `Reserved words`,
        html: [['p',
            [` One space after reserved words before the opening parenthesis,
                except for `,
            ['code',
                [`function`],
            ],
            ` and `,
            ['code',
                [`catch`],
            ],
            ` (which is function like): `],
        ],
        ['pre',
            [`if(close_file)
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (close_file)
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`for(i=0; !is_last(i); i++);
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`for (i=0; !is_last(i); i++);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`try{ code; } catch (e) { code; }
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`try { code; } catch(e){ code; }
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var t = function (api) { api('test'); };
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var t = function(api){ api('test'); };
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-block-try_catch',
        title: `
  try-catch`,
        tag: 'h4',
        short: `try-catch`,
        html: [['p',
            [` Multiline `,
            ['code',
                [`try`],
            ],
            `: close block on `,
            ['code',
                [`catch`],
            ],
            ` line (like `,
            ['code',
                [`do-while`],
            ],
            `): `],
        ],
        ['pre',
            [`try { short_code; } catch(e){ code; }
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`try {
    longer_code; }
catch(e){ code; }
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`try {
    and_even;
    longer_code;
} catch(e){ code; }
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Catch variable should be named 'e'`],
        ],
        ['pre',
            [`try { res = yield etask.nfn_apply(zmongo.collection, '.save', [obj]); }
catch(error){ handle_error(zmongo, 'save', error, obj); }
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`try { res = yield etask.nfn_apply(zmongo.collection, '.save', [obj]); }
catch(e){ handle_error(zmongo, 'save', e, obj); }
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-block-operator',
        title: `Operator spacing`,
        tag: 'h4',
        short: `Operator spacing`,
        html: [['p',
            [` both sides should be equal: either space before and after, or
                no spaces at all. `],
        ]],
    },
    {
        id: 'format-block-operator-trivial',
        title: `
  Trivial > >= < <= == != expressions`,
        tag: 'h5',
        short: `Trivial expressions`,
        html: [['p',
            [` Trivial `,
            ['code',
                [`> >= < <= == !=`],
            ],
            ` expressions should not have spaces around them: `,
            ['code',
                [`a_var`],
            ],
            `. `],
        ],
        ['pre',
            [`if (x> 5)
if (x >5)
if (x > 5)
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (x>5)
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [` Nearly-trivial expressions can be with or without spaces: `,
            ['code',
                [`a[3]`],
            ],
            `, `,
            ['code',
                [`f(x)`],
            ],
            `, `,
            ['code',
                [`x.y.z`],
            ],
            `, `,
            ['code',
                [`a.b.c(x, y, z)`],
            ],
            `. `],
        ],
        ['pre',
            [`if (f(x, y) > g(y, z))
if (f(x, y)>g(y, z))
if (x.y == 5)
if (x.y==5)
if (x.y>=5)
if (x.y >= 5)
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [` We consider simple short arithmetics also as nearly-trivial
                expressions: `,
            ['code',
                [`x+1`],
            ],
            `, `,
            ['code',
                [`2*x`],
            ],
            `. `],
        ],
        ['pre',
            [`if (x+1>5)
if (x+1 > 5)
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`if one side is not trivial, then must have spaces.`],
        ],
        ['pre',
            [`if (a&&a.b)
if (a && a.b)
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (!a&&a.b)
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (!a && a.b)
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`if one side is long, then prefer to have spaces.`],
        ],
        ['pre',
            [`if (a&&Array.isArray(a))
`],
            {className: `cm-s-default code ok  has-popover`,
                cat: `ok`,
                'data-content': `OK`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (a && Array.isArray(a))
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-block-operator-assign',
        title: `
  Assignments spaces`,
        tag: 'h5',
        short: `Assignments spaces`,
        html: [['p',
            [` Spaces around assignments `,
            ['code',
                [`= += -= *= /= &= |=`],
            ],
            ` are not mandatory in `,
            ['code',
                [`for()`],
            ],
            ` loops. `],
        ],
        ['pre',
            [`a=b;
d+=x;
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`a = b;
d += x;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`for (i=0; i<10; i+=4);
for (i = 0; i<10; i += 4);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-block-operator-unary',
        title: `Unary operators`,
        tag: 'h5',
        short: `Unary operators`,
        html: [['p',
            [` Don't put a space after `,
            ['code',
                [`++`],
            ],
            ['code',
                [`--`],
            ],
            ['code',
                [`!`],
            ],
            `, and other unary operators. increment after the value, not
                before. `],
        ],
        ['pre',
            [`i --;
++j;
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`i--;
j++;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (! i)
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (!i)
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var speed_int = + speed_str;
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var speed_int = +speed_str;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-block-operator-multi',
        title: `
  Multiple +`,
        tag: 'h5',
        short: `Multiple +`,
        html: [['p',
            [` Multiple `,
            ['code',
                [`+`],
            ],
            ` operators are trivial expressions, and thus we prefer not to
                put spaces around them (such as string concatenation). `],
        ],
        ['pre',
            [`msg = 'hello ' + name + '!';
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`msg = 'hello '+name+'!';
msg = 'hello '+get_my_name()+'!';
msg = 'hello ' + get_my_name()+'!';
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-block-operator-cond',
        title: `
  Conditionals ? :`,
        tag: 'h5',
        short: `Conditionals`,
        html: [['p',
            [['code',
                [`? :`],
            ],
            ` should have spaces all around them.`],
        ],
        ['pre',
            [`var msg = login_ok?'Welcome':'Please login';
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var msg = login_ok ? 'Welcome' : 'Please login';
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-minimal',
        title: `Minimalism`,
        tag: 'h3',
        short: `Minimal code`,
        html: [],
    },
    {
        id: 'format-minimal-unneeded_parentheses',
        title: `
  Do not use unneeded parentheses in expressions:`,
        tag: 'h4',
        short: `Unneeded parentheses`,
        html: [['pre',
            [`if ((a!=b) || (c!=d))
    ...
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (a!=b || c!=d)
    ...
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-minimal-empty_line',
        title: `
  Avoid empty lines`,
        tag: 'h4',
        short: `Avoid empty lines`,
        html: [['p',
            [` Never in any case have two empty lines together.`,
            ['br'],
            ` A single empty line is allowed in global scope and between
                functions, but use it sparsely.`,
            ['br']],
        ]],
    },
    {
        id: 'format-minimal-separate_line',
        title: `
  Separate line`,
        tag: 'h4',
        short: `Separate line`,
        html: [['p',
            [` Should not separate with more than one blank line between
                sections, functions etc. `],
        ],
        ['pre',
            [`function init(){ ...; };


function end(){ ...; };
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`function init(){ ...; };

function end(){ ...; };
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`function init(){ ...; };
function end(){ ...; };
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [` Inside functions, should never have an empty line. Use
                comments to separate. `],
        ],
        ['pre',
            [`function setup_conn(orig){
    var conn = net.connect(dst);
    conn.pipe(orig);

    conn.set_speed('fast');
    if (conn.rx>MAX_SPEED)
        conn.set_speed('medium');
    return conn;
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`function setup_conn(orig){
    var conn = net.connect(dst);
    conn.pipe(orig);
    // setup speed
    conn.set_speed('fast');
    if (conn.rx>MAX_SPEED)
        conn.set_speed('medium');
    return conn;
}
`],
            {className: `cm-s-default code ok  has-popover`,
                cat: `ok`,
                'data-content': `OK`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`function setup_conn(orig){
    var conn = net.connect(dst);
    conn.pipe(orig);
    conn.set_speed('fast');
    if (conn.rx>MAX_SPEED)
        conn.set_speed('medium');
    return conn;
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-minimal-arrow_func',
        title: `
  Arrow function short syntax`,
        tag: 'h5',
        short: `Arrow function short syntax`,
        html: [['p',
            [`When possible, use arrow function short syntax`],
        ],
        ['pre',
            [`let t = data=>{ return do_something(data); }
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`let t = data=>do_something(data);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-minimal-separate_line-return',
        title: `return statements`,
        tag: 'h4',
        short: `return statements`,
        html: [],
    },
    {
        id: 'format-minimal-separate_line-return-min',
        title: `Minimal return statement`,
        tag: 'h5',
        short: `Minimal return statement`,
        html: [['p',
            [['code',
                [`return`],
            ],
            ` statements should not have parentheses and should not have a
                space after them:`],
        ],
        ['pre',
            [`return (0);
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`return 0;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`return ;
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`return;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-minimal-separate_line-return-undefined',
        title: `return undefined`,
        tag: 'h5',
        short: `return undefined`,
        html: [['p',
            [`For `,
            ['code',
                [`return undefined`],
            ],
            `, just do `,
            ['code',
                [`return`],
            ],
            `, `,
            ['code',
                [`undefined`],
            ],
            ` is the default of JS.`],
        ],
        ['p',
            [`If a function returns `,
            ['code',
                [`undefined`],
            ],
            ` at exit, you don't need to call `,
            ['code',
                [`return`],
            ],
            `.`],
        ],
        ['pre',
            [`function x(x){
    if (!x)
        return undefined;
    ...;
    if (x_is_valid(x))
        return x+5;
    ...;
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`function x(x){
    if (!x)
        return;
    ...;
    if (x_is_valid(x))
        return x+5;
    ...;
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-minimal-return-assign',
        title: `
  return an assignment`,
        tag: 'h5',
        short: `return an assignment`,
        html: [['p',
            [`You may return an assignment in order to merge assignment and
                return statments. Do not add unneeded brackets`],
        ],
        ['pre',
            [`return (a = b);
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`return a = b;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-minimal-return-void_cast',
        title: `Cast to void`,
        tag: 'h5',
        short: `Cast to void`,
        html: [['p',
            [`You may 'cast' to `,
            ['code',
                [`void`],
            ],
            ` in order to merge an action and `,
            ['code',
                [`return undefined`],
            ],
            ` into a single line.`],
        ],
        ['pre',
            [`return void sock.close();
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (ret)
    return void (cache[id] = ret);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (clock)
    clock = void clock.restore();
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-minimal-eqal-zero',
        title: `Compare to 0`,
        tag: 'h4',
        short: `compare to 0`,
        html: [['p',
            [`When 0 stands as non valid or empty option, avoid comparing to
                0`],
        ],
        ['pre',
            [`if (total==0)
    return 'NA';
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (!total)
    return 'NA';
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-long_string',
        title: `Long strings`,
        tag: 'h3',
        short: `Long strings`,
        html: [['p',
            [` Breaking up long strings: no space around `,
            ['code',
                [`+`],
            ],
            `, and prefer `,
            ['code',
                [`+`],
            ],
            ` at beginning of next line. `],
        ],
        ['pre',
            [`msg = 'this ' +
    'is a long string.';
msg = 'this '
    + 'is a long string.';
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`msg = 'this '+
    'is a long string.';
msg = 'this '
    +'is a long string.';
`],
            {className: `cm-s-default code ok  has-popover`,
                cat: `ok`,
                'data-content': `OK`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`msg = 'this '
+'is a long string.';
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Space, if needed should be at the end of each line and not at
                the beginning of the next line`],
        ],
        ['pre',
            [`msg = 'this'
+' is a long string';
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`msg = 'this '
+'is a long string';
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-file_lvl_closure',
        title: `
  File-level closures`,
        tag: 'h3',
        short: `File-level closures`,
        html: [['p',
            [`File-level closures: do not indent the whole file. leave a
                space after the opening, and before the closing:`],
        ],
        ['pre',
            [`(function($, chrome, console){
    code;
    code;
})(jQuery, chrome, console);
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`(function($, chrome, console){

code;
code;

})(jQuery, chrome, console);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-file_template',
        title: `JS file template`,
        tag: 'h3',
        short: `JS file template`,
        html: [],
    },
    {
        id: 'format-file_template-browser',
        title: `
  IE/Chrome/FF template`,
        tag: 'h4',
        short: `IE/Chrome/FF template`,
        html: [['pre',
            [`// LICENSE_CODE ZON
'use strict'; /*jslint browser:true*/
`],
            {className: `cm-s-default code  `,
                cat: ``},
        ]],
    },
    {
        id: 'format-file_template-nodejs_app',
        title: `NodeJS application template`,
        tag: 'h4',
        short: `NodeJS application template`,
        html: [['pre',
            [`#!/usr/bin/env node
// LICENSE_CODE ZON
'use strict'; /*jslint node:true*/
require('util/config.js');
`],
            {className: `cm-s-default code  `,
                cat: ``},
        ]],
    },
    {
        id: 'format-file_template-nodejs_mod',
        title: `
  NodeJS module template`,
        tag: 'h4',
        short: `NodeJS module template`,
        html: [['pre',
            [`// LICENSE_CODE ZON
'use strict'; /*jslint node:true*/
require('util/config.js');
`],
            {className: `cm-s-default code  `,
                cat: ``},
        ]],
    },
    {
        id: 'format-require',
        title: `require()`,
        tag: 'h3',
        short: `require()`,
        html: [['p',
            [` Local packages should include `,
            ['code',
                [`.js`],
            ],
            ` in the name. Global packages should be the package name only
                (`,
            ['code',
                [`NODE_PATH`],
            ],
            ` environment variable should be defined). `],
        ],
        ['pre',
            [`const express = require('/usr/lib/node_modules/express');
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`const express = require('express');
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`const get_rules = require('./get_rules');
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`const get_rules = require('./get_rules.js');
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [['code',
                [`require`],
            ],
            ` should be called at the top of the file, not locally, so that
                unit-tests will surface all the problems.`],
        ],
        ['pre',
            [`function readconf(){
    return require('fs').readFileSync('conf'); }
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`// top of file...
const fs = require('fs');
// later down in the file...
function f(){
    return fs.readFileSync('conf'); }
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Constants and variable names of required modules should
                normally be the same, according to the module name.`],
        ],
        ['pre',
            [`const rules = require('./get_rules.js'); // in foo.js
const actions = require('./get_rules.js'); // in bar.js
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`const get_rules = require('./get_rules.js'); // in foo.js and bar.js
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Use `,
            ['code',
                [`_`],
            ],
            ` instead of `,
            ['code',
                [`-`],
            ],
            ['code',
                [`/`],
            ]],
        ],
        ['pre',
            [`const node_getopt = require('node-getopt');
const svc_reconf = require('../svc/reconf.js');
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [` Always prepend `,
            ['code',
                [`z`],
            ],
            ` to variable names for the following modules from `,
            ['code',
                [`pkg/util`],
            ],
            `, and, when necessary, for other modules that clash with global
                packages. `],
        ],
        ['pre',
            [`const zconf = require('util/config.js');
const zconf = require('util/config_int.js');
const zescape = require('util/escape.js');
const zhttp = require('util/zhttp.js');
const zhttp = require('util/http.js');
const zurl = require('util/url.js');
const zutil = require('util/util.js');
const zos = require('util/os.js');
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`You may drop the `,
            ['code',
                [`node-`],
            ],
            ` prefix, or `,
            ['code',
                [`-js`],
            ],
            ` suffix. `],
        ],
        ['pre',
            [`const getopt = require('node-getopt');
const uglify = require('uglify-js');
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Special modules with short names: jquery and lodash.`],
        ],
        ['pre',
            [`var $ = require('jquery');
var _ = require('lodash');
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-comment',
        title: `Comments`,
        tag: 'h3',
        short: `Comments`,
        html: [],
    },
    {
        id: 'format-comment-comment_cpp',
        title: `
  Prefer C++ comment over C comments.`,
        tag: 'h4',
        short: `Prefer C++ comment over C comments.`,
        html: [['pre',
            [`/* close all files */
fclose(fp);
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`// close all files
fclose(fp);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`/* multi
 * line
 * comment */
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`// multi
// line
// comment
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-comment-aligned',
        title: `Comments aligned`,
        tag: 'h4',
        short: `Comments aligned`,
        html: [['p',
            [`Comments should be aligned as the code they comment, or one
                space after the end of the line.`],
        ],
        ['pre',
            [`/*
 * close all files
 */
fclose(fp);
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`/* close all files */
fclose(fp);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`fclose(fp); /* close all files */
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-comment-long',
        title: `Long comments`,
        tag: 'h4',
        short: `Long comments`,
        html: [['p',
            [`Comments which occupy more than one line should adhere to the
                following guideline:`],
        ],
        ['pre',
            [`//
// close all the files that were opened before the function was called
// and send them to the output file
//
fclose(fp);
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`// close all the files that were opened before the function was called
// and send them to the output file
fclose(fp);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-comment-multiline',
        title: `
  Multiline comments`,
        tag: 'h4',
        short: `Multiline comments`,
        html: [['p',
            [`Multiline comments should always be on their own, not continue
                on existing statements. If longer, put the comment at the
                line above.`],
        ],
        ['pre',
            [`var isa_pnp_scan = {
    search_id: 'a-test', // if search_id.vendor[0]==0 - scan all vendor
                         // IDs
                         // if searchId.dwSerial==0 - scan all serial
                         // numbers
    cards: 2, // number of cards found
    card: [card1, card2], // cards found
};
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var isa_pnp_scan = {
    search_id: 'a-test',  // if search_id.vendor[0]==0 - scan
                          // all vendor IDs
                          // if searchId.dwSerial==0 - scan all
                          // serial numbers
    cards: 2,             // number of cards found
    card: [card1, card2]; // cards found
};
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var isa_pnp_scan = {
    // if search_id.vendor[0]==0 - scan all vendor IDs
    // if searchId.dwSerial==0 - scan all serial numbers
    search_id: 's-test',
    cards: 2, // number of cards found
    card: [card1, card2], // cards found
};
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-comment-xxx',
        title: `XXX - todo mark`,
        tag: 'h4',
        short: `XXX - todo mark`,
        html: [['p',
            [` Comments of `,
            ['code',
                [`XXX`],
            ],
            ` should be used for temporary code, that would be changed in
                the future: hack, quick workaround, non-elegant code, bug.
                They should be `,
            ['code',
                [`XXX [login]: COMMENT`],
            ],
            `, multiple names should be separated with `,
            ['code',
                [`/`],
            ],
            `. `],
        ],
        ['pre',
            [`XXX derry: ANDROID move to compat
XXX derry: arik: move to compat
XXX derry arik: move to compat
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`XXX derry: move to compat
XXX derry ANDROID: move to compat
XXX derry/arik: move to compat
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [['code',
                [`XXX`],
            ],
            ` comments are tasks, so they should always have someone
                assigned. `,
            ['a',
                [`Preferably yourself`],
                {href: `/dna#individual-solve`},
            ],
            `! `],
        ],
        ['pre',
            [`XXX: move to compat
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`XXX some-other-developer: move to compat
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`XXX derry: move to compat
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [` Using XXX comments can be used, when needed, to override any
                possible rules! `],
        ],
        ['pre',
            [`if (0)
it('pause_disconnect', ()=>etask(function*(){
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (0) // XXX sergey: lots of sporadic failues
it('pause_disconnect', ()=>etask(function*(){
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`// XXX derry: copied urgent gist as-is to hack around a bug from angular
// http://github.com/....
// will fix by 8-Nov-2016
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-loop',
        title: `Loops`,
        tag: 'h3',
        short: `Loops`,
        html: [],
    },
    {
        id: 'format-loop-for_vs_while',
        title: `
  for vs while`,
        tag: 'h4',
        short: `for vs while`,
        html: [['p',
            [` If a `,
            ['code',
                [`while`],
            ],
            ` loop has an `,
            ['code',
                [`init`],
            ],
            ` and/or `,
            ['code',
                [`next`],
            ],
            ` expression, then use a `,
            ['code',
                [`for`],
            ],
            ` loop: `],
        ],
        ['pre',
            [`i = 0;
while (i<10)
{
     ...;
     i++;
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`for (i = 0; i<10; i++)
    ...;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [` If a `,
            ['code',
                [`for`],
            ],
            ` loop has only a `,
            ['code',
                [`condition`],
            ],
            `, then use `,
            ['code',
                [`while`],
            ],
            `: `],
        ],
        ['pre',
            [`for (; have_more();)
    ...;
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`while (have_more())
    ...;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [` If no `,
            ['code',
                [`init`],
            ],
            `/`,
            ['code',
                [`condition`],
            ],
            `/`,
            ['code',
                [`next`],
            ],
            `, then any option is ok: `],
        ],
        ['pre',
            [`for (;;)
    do_endless_work();
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`while (1)
    do_endless_work();
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-loop-for',
        title: `for loops`,
        tag: 'h4',
        short: `for loops`,
        html: [['p',
            [` In `,
            ['code',
                [`for`],
            ],
            ` loops, when there is a function that gets the next element, it
                should be done once (inside the step condition):`,
            ['br'],
            ` assign inside a statement: `],
        ],
        ['pre',
            [`for (i = 0, result = get_char(); result=='\\r'; result = get_char(), i++)
    handle_result(result);
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`for (i = 0; (result = get_char())=='\\r'; i++)
    handle_result(result);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-loop-do_while',
        title: `
  do-while`,
        tag: 'h4',
        short: `do-while`,
        html: [['p',
            [['code',
                [`do-while`],
            ],
            `: long `,
            ['code',
                [`do`],
            ],
            ` block should be closed on `,
            ['code',
                [`while`],
            ],
            ` line: `],
        ],
        ['pre',
            [`do add_item();
while (have_items);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`do
    add_item();
while (have_items);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`do {
    add_item();
    another_action();
} while (have_items);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-spacing',
        title: `Spacing`,
        tag: 'h3',
        short: `Spacing`,
        html: [['p',
            [`Put one space before and after an assignment.`],
        ],
        ['pre',
            [`var a=0;
x= x+1;
bits|=BIT5;
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var a = 0;
x = x+1;
bits |= BIT5;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`If it is in a `,
            ['code',
                [`for`],
            ],
            ` loop, you can skip the spaces. if you skip one of the spaces,
                skip both:`],
        ],
        ['pre',
            [`for (i= 0; i; i--)
    printf("%d", i);
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`for (i=0; i; i--)
    printf("%d", i);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`for (i = 0; i; i--)
    printf("%d", i);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Don't put a space before a statement separator, put one after
                it:`],
        ],
        ['pre',
            [`for (i=0 ;i ;i--, j*=2) ;
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`for (i=0; i; i--, j*=2);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`for (i = 0; i; i--, j *= 2);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-callfail',
        title: `
  Check fail in same line of call`,
        tag: 'h3',
        short: `Check fail in same line of call`,
        html: [['p',
            [` Prefer to check for failures in same line of calling the
                function. `],
        ],
        ['pre',
            [`i = str.indexOf("\\r\\n");
if (i<0)
    return;
`],
            {className: `cm-s-default code not_preferred  has-popover`,
                cat: `not_preferred`,
                'data-content': `NOT PREFERRED`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if ((i = str.indexOf("\\r\\n"))<0)
    return;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`m = str.match("EOF");
if (!m)
    return;
`],
            {className: `cm-s-default code not_preferred  has-popover`,
                cat: `not_preferred`,
                'data-content': `NOT PREFERRED`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (!(m = str.match("EOF")))
    return;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-object',
        title: `Object notation`,
        tag: 'h3',
        short: `Object notation`,
        html: [['pre',
            [`var node =
{
    name: 'server',
    port: 42,
    status: 'updated',
    setup_time: 10*1000,
};
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var node = {
    name: 'server',
    port: 42,
    status: 'updated',
    setup_time: 10*1000,
};
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Multiline objects: should have a comma after last property.`],
        ],
        ['pre',
            [`var node = {
    name: 'server',
    status: 'updated',
    setup_time: 10*1000
};
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var node = {
    name: 'server',
    status: 'updated',
    setup_time: 10*1000,
};
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Short objects: should be in a single line if they are very
                short.`],
        ],
        ['pre',
            [`var node = {name: 'server', port: 42,};
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var node = {
    name: 'server',
    port: 42,
};
`],
            {className: `cm-s-default code ok  has-popover`,
                cat: `ok`,
                'data-content': `OK`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var node = {name: 'server', port: 42};
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Object contains short object: should be in a single line.`],
        ],
        ['pre',
            [`var node = {info: {name: 'server', port: 42},
};
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var node = {
    info: {name: 'server', port: 42},
};
`],
            {className: `cm-s-default code ok  has-popover`,
                cat: `ok`,
                'data-content': `OK`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var node = {info: {name: 'server', port: 42}};
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Objects spacing:`],
        ],
        ['ul',
            [['li',
                [`before `,
                ['code',
                    [`,`],
                ],
                ` and `,
                ['code',
                    [`:`],
                ],
                ` signs, there should not be a space, while after those
                    signs, space is required.`],
            ],
            ['li',
                [`after `,
                ['code',
                    [`{`],
                ],
                ` and before `,
                ['code',
                    [`}`],
                ],
                ` signs, there should not be a space.`],
            ]],
        ],
        ['pre',
            [`var node = {name: 'server', port: 42};
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var node = {name: 'server' , port: 42};
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var node = {name : 'server', port : 42};
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var node = { name: 'server', port: 42 };
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-casting',
        title: `Casting`,
        tag: 'h3',
        short: `Casting`,
        html: [['p',
            [` Convert to number: `,
            ['code',
                [`+val`],
            ],
            ['br'],
            ` Convert to signed 32bit int: `,
            ['code',
                [`val|0`],
            ],
            ['br'],
            ` Convert to unsigned 32bit int: `,
            ['code',
                [`val>>>0`],
            ],
            ['br'],
            ` Convert to Boolean: `,
            ['code',
                [`!!val`],
            ],
            ['br'],
            ` Convert Boolean to 0/1: `,
            ['code',
                [`+bool_val`],
            ],
            ` or `,
            ['code',
                [`+!!any_val`],
            ],
            ['br'],
            ['br'],
            ` String literals: prefer `,
            ['code',
                [`'single quotes'`],
            ],
            ` over `,
            ['code',
                [`"double quotes"`],
            ],
            ['br']],
        ],
        ['pre',
            [`"I am the walrus."
`],
            {className: `cm-s-default code ok  has-popover`,
                cat: `ok`,
                'data-content': `OK`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`'I am the walrus.'
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`"I'm the walrus."
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-export',
        title: `exports`,
        tag: 'h3',
        short: `exports`,
        html: [],
    },
    {
        id: 'format-export-e',
        title: `
  Use variable E as alias to exports.`,
        tag: 'h4',
        short: `exports E`,
        html: [['pre',
            [`exports.foo = function(){ ... };
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`const E = exports;
E.foo = function(){ ... };
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-export-function',
        title: `
  Export functions`,
        tag: 'h4',
        short: `Export functions`,
        html: [['p',
            [` Only export functions which are used outside of the module,
                keep everything else local. `],
        ],
        ['pre',
            [`E.internal_helper = function(){ ... };
...
E.internal_helper();
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`function internal_helper(){ ... }
...
internal_helper();
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-export-test',
        title: `
  Unit-test exports`,
        tag: 'h4',
        short: `Unit-test exports`,
        html: [['p',
            [` Use variable `,
            ['code',
                [`E.t`],
            ],
            ` for exports only used in tests, give the function name to use
                inside module. `],
        ],
        ['pre',
            [`// in foo.js
E.internal_function = function(){ ... };
...
E.internal_function();

// in test.js
foo.internal_function();
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`// in foo.js
const E = exports;
...
function internal_function(){ ... }
...
internal_function();
...
E.t = {internal_function: internal_function, ...};
// in test.js
foo.t.internal_function();
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-continuation_method',
        title: `
  Continuation .method()
`,
        tag: 'h3',
        short: `Continuation .method()`,
        html: [['p',
            [`Continuation `,
            ['code',
                [`.method()`],
            ],
            ` or `,
            ['code',
                [`+'str'`],
            ],
            ` on next line can be same indentation as parent line. Same goes
                for single `,
            ['code',
                [`var`],
            ],
            ` definition, and `,
            ['code',
                [`return`],
            ],
            `. `],
        ],
        ['pre',
            [`$('<h1>', $('<div>')
.append('<span>'));
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`$('<h1>', $('<div>')
    .append('<span>'));
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`$('<div>')
    .append('<span>');
`],
            {className: `cm-s-default code ok  has-popover`,
                cat: `ok`,
                'data-content': `OK`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`$('<div>')
.append('<span>');
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`elm = $('<span>')
.append('<span>');
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var elm = $('<span>')
.append('<span>');
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var e1 = $('<div>'), e2 = $('<span>')
.append('<span>');
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var e1 = $('<div>');
var e2 = $('<span>')
.append('<span>');
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`return $('<div>')
.append('<span>');
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`return $('<h2>', $('<div>')
.append('<span>'));
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`return $('<h2>', $('<div>')
    .append('<span>'));
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var s = '<div>'
+'<span>';
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`s = x ? '<child>' : '<nothing>'
+'<span>';
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`s = '<div>'
+'<span>';
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`return '<div>'
+'<span>';
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-dot_method',
        title: `
  . of .method()`,
        tag: 'h3',
        short: `. of .method()`,
        html: [['p',
            [['code',
                [`.`],
            ],
            ` of `,
            ['code',
                [`.method()`],
            ],
            ` MUST be the first character on a method call continuation
                line. `],
        ],
        ['pre',
            [`set_user(db.open('users').
  get$(user));
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`set_user(db.open('users')
  .get$(user));
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`$('<h1>', $('<div>').
    append('<span>'));
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`$('<h1>', $('<div>')
    .append('<span>'));
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-var_declaration',
        title: `
  Variable declarations`,
        tag: 'h3',
        short: `Variable declarations`,
        html: [['p',
            [['code',
                [`var`],
            ],
            ` declarations longer than one line must have their own `,
            ['code',
                [`var`],
            ],
            `. `],
        ],
        ['pre',
            [`var a = 'test',
    b = f('another', 'test'),
    c = 'yet another';
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var a = 'test';
var b = f('another', 'test');
var c = 'yet another';
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var a = 'test';
var b = f('another', 'test'), c = 'yet another';
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var a = 'test', b = f('another', 'test'), c = 'yet another';
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var a = 'test', b = f('another',
    'test');
var c = 'yet another';
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var a = 'test';
var b = f('another',
    'test');
var c = 'yet another';
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-var_compare',
        title: `Comparing variables`,
        tag: 'h3',
        short: `Comparing variables`,
        html: [['p',
            [` When comparing to `,
            ['code',
                [`undefined`],
            ],
            ` use `,
            ['code',
                [`===`],
            ],
            ` and `,
            ['code',
                [`!==`],
            ],
            ` On any other case, use `,
            ['code',
                [`==`],
            ],
            ` and `,
            ['code',
                [`!=`],
            ]],
        ],
        ['pre',
            [`if (a==='OK')
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (typeof a==='undefined')
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (a=='OK')
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (a===undefined)
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-use_bind',
        title: `
  Prefer .bind() over this`,
        tag: 'h3',
        short: `Use bind().`,
        html: [['p',
            [` When assigning functions that depend on `,
            ['code',
                [`this`],
            ],
            `, use `,
            ['code',
                [`bind()`],
            ],
            `. `],
        ],
        ['pre',
            [`var log = console.log;
log('a'); // TypeError: Illegal invocation
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var log = console.log.bind(console);
log('a');
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-locality',
        title: `
  Shorten using locality`,
        tag: 'h3',
        short: `Locality`,
        html: [['p',
            [` Use locality to shorten names, relying on the contexts of the
                local code scope. `],
        ],
        ['pre',
            [`for (let opration_idx=0; operation_idx<operations.length; operation_idx++)
    ...;
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`for (let i=0; i<operations.length; i++)
    ...;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`for (let allowed_customer in allowed_customers)
    ...;
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`for (let c in allowed_customers)
    ...;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-notation',
        title: `
  UNIX notation naming`,
        tag: 'h3',
        short: `UNIX notation naming`,
        html: [['p',
            [`Code will be in UNIX notation. UNIX names should not include
                the data type, rather the meaning of the information in the
                data.`],
        ],
        ['pre',
            [`var bIsCompleted;
var iCount;
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var is_completed, data, vendor_id, count, buffer, new_name, name;
function read_data_block(){}
const MS_PER_SEC = 1000;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-notation-neg',
        title: `Positive naming`,
        tag: 'h4',
        short: `positive naming`,
        html: [['p',
            [`Default to using positive naming, rather than negative
                (no/not/disable...). This helps avoid double negation (not
                not).`],
        ],
        ['pre',
            [`if (!not_customer(customer))
    disable_customer(customer, false);
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (is_customer(customer))
    enable_customer(customer, true);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var no_rule = lookup_rule(rule)<0;
if (!no_rule)
    rm_rule();
else
    add_rule();
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var have_rule = lookup_rule(rule)>=0;
if (have_rule)
    rm_rule();
else
    add_rule();
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-simplicity_usability',
        title: `Simplicity
  and usability`,
        tag: 'h4',
        short: `simplicity and usability`,
        html: [['p',
            [`Command line options, or option variable (opt), use common
                usage as default even if negative`],
        ],
        ['pre',
            [`zlxc --browser
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`zlxc --no-browser
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`opt = {exit_on_err: 1};
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`opt = {no_exit: 1};
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-default_value',
        title: `Default value`,
        tag: 'h4',
        short: `default value`,
        html: [['p',
            [`Using implicit `,
            ['code',
                [`undefined`],
            ],
            ` as default value`],
        ],
        ['pre',
            [`let need_reconf = false;
if (is_host(':servers'))
    need_reconf = true;
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`let need_reconf = undefined
if (is_host(':servers'))
    need_reconf = true;
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`let need_reconf;
if (is_host(':servers'))
    need_reconf = true;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-poly_func',
        title: `
  Multi-signature functions`,
        tag: 'h3',
        short: `Multi-signature functions`,
        html: [['p',
            [` For functions that have multiple signatures or where there is
                an optional (not last) argument, you may optionally add the
                different possible signatures as a comment, in the nodejs
                signature documentation style. `],
        ],
        ['pre',
            [`// _apply(opt, func[, _this], args)
// _apply(opt, object, method, args)
E._apply = function(opt, func, _this, args){
    ...
};
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-this_value',
        title: `
  Saving the value of this`,
        tag: 'h3',
        short: `Saving the value of \`this\``,
        html: [['p',
            [` When saving the value of `,
            ['code',
                [`this`],
            ],
            ` for use in lexically nested functions, use `,
            ['code',
                [`_this`],
            ],
            ` as the variable name. `],
        ],
        ['pre',
            [`var self = this;
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`var _this = this;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`function on_end(opt){
    var _this = this;
    return function on_end_cb(msg){
        if (_this.socket)
             return 'socket';
    };
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Use `,
            ['code',
                [`__this`],
            ],
            ` and `,
            ['code',
                [`___this`],
            ],
            `... for deep code.`],
        ],
        ['pre',
            [`function on_end(opt){
    var _this = this;
    return function(msg){
        if (_this.socket)
             return 'socket';
        var __this = this;
        setTimeout(function(){ __this.socket = undefined; }, 1000);
    };
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-function_classes',
        title: `
  Functions as class definition`,
        tag: 'h3',
        short: `Functions as class definition`,
        html: [['p',
            [`When a function is a class definition, e.g. needs `,
            ['code',
                [`new`],
            ],
            ` in order to use it, it should start with capital letter`],
        ],
        ['pre',
            [`function etask(opt, states){
    ...
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`function Etask(opt, states){
    ...
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-es6',
        title: `ES6`,
        tag: 'h3',
        short: `ES6`,
        html: [],
    },
    {
        id: 'format-es6-arrow',
        title: `Arrow functions`,
        tag: 'h4',
        short: `Arrow functions`,
        html: [['p',
            [` No spaces around `,
            ['code',
                [`=>`],
            ],
            `. Prefer to drop `,
            ['code',
                [`()`],
            ]],
        ],
        ['pre',
            [`e.on('play', () => {
    player.start();
    started = 1;
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`e.on('play', ()=>{
    player.start();
    started = 1;
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`socket.on('connect', ()=> state = 'CONNECTED' );
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`socket.on('connect', ()=>state = 'CONNECTED');
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`docs.forEach(doc => add(doc));
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`docs.forEach(doc=>add(doc));
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`docs.forEach((doc, index)=>{
    if (index)
        add(doc, index);
});
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Drop `,
            ['code',
                [`()`],
            ],
            ` around single argument.`],
        ],
        ['pre',
            [`docs.forEach((doc)=>add(doc));
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`docs.forEach(doc=>add(doc));
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Prefer to drop `,
            ['code',
                [`{}`],
            ],
            ` around single short statement.`],
        ],
        ['pre',
            [`docs.forEach(doc=>{ add(doc); });
`],
            {className: `cm-s-default code ok  has-popover`,
                cat: `ok`,
                'data-content': `OK`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`docs.forEach(doc=>add(doc));
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-es6-preferred_method',
        title: `
  Preferred Methods`,
        tag: 'h4',
        short: `Preferred Methods`,
        html: [['p',
            [` never use `,
            ['code',
                [`.indexOf()`],
            ],
            ` for arrays/strings when `,
            ['code',
                [`.includes()`],
            ],
            ` fits. `],
        ],
        ['pre',
            [`if (apps.indexOf(zserver_match[1])<0)
    apps.push(zserver_match[1]);
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (!apps.includes(zserver_match[1]))
    apps.push(zserver_match[1]);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [` never user `,
            ['code',
                [`.indexOf()`],
            ],
            ` for strings when `,
            ['code',
                [`.startsWith()`],
            ],
            ` fits. `],
        ],
        ['pre',
            [`return !patch[0].indexOf(changed_file)
    || !patch[1].indexOf(changed_file);
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`return patch[0].startsWith(changed_file)
    || patch[1].startsWith(changed_file);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-es6-generator',
        title: `Generators`,
        tag: 'h4',
        short: `Generators`,
        html: [['p',
            [`No spaces around `,
            ['code',
                [`*`],
            ],
            `.`],
        ],
        ['pre',
            [`etask(function* (){
    ...
});
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`etask(function*(){
    ...
});
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`etask(function * get_request(){
    ...
});
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`etask(function*get_request(){
    ...
});
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-es6-class',
        title: `Class definition`,
        tag: 'h4',
        short: `Class definition`,
        html: [['p',
            [`Class name start with capital leter`],
        ],
        ['pre',
            [`class SimpleView {}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`class simple_view {}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`class Simple_view {}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Add space between class name and `,
            ['code',
                [`{`],
            ]],
        ],
        ['pre',
            [`class A{}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`class A {}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'format-es6-class-etask',
        title: `Etask methods`,
        tag: 'h4',
        short: `Etask methods`,
        html: [['p',
            [`Indentation reducing is allowed, but class methods should be
                indented`],
        ],
        ['pre',
            [`class A {
    prop(){
        return etask(function*(){
            code;
        });
    }
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`class A {
    prop(){ return etask(function*(){
        code;
    }); }
}
`],
            {className: `cm-s-default code ok  has-popover`,
                cat: `ok`,
                'data-content': `OK`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`class A {
prop(){
    let _this = this;
return etask(function*(){
    code;
    });
}
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`class A {
    prop(){
        let _this = this;
    return etask(function*(){
        code;
    }); }
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'prog_tech',
        title: `Programming technique`,
        tag: 'h2',
        short: `Programming technique`,
        html: [],
    },
    {
        id: 'prog_tech-generic',
        title: `Generic code`,
        tag: 'h3',
        short: `Generic code`,
        html: [['p',
            [` Code should be written generically only if during the time you
                are writing it, it is called at least twice, if not more,
                and save code in the caller.`,
            ['br'],
            ` Generic code need a deeper unit-tests then regular code. `],
        ],
        ['pre',
            [`E.first_weekday_of_month = function(wd, d){
    ...
};
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`E.strftime = function(fmt, d, opt){
    ...
};
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'prog_tech-early_return',
        title: `
  Early return`,
        tag: 'h3',
        short: `Early return`,
        html: [['p',
            [`Avoid `,
            ['code',
                [`if()`],
            ],
            ` on 50% or more of a function.`],
        ],
        ['pre',
            [`let inited;
E.init = ()=>{
    if (!inited)
    {
        inited = true;
        register_app();
        set_timers();
    }
};
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`let inited;
E.init = ()=>{
    if (inited)
        return;
    inited = true;
    register_app();
    set_timers();
};
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'prog_tech-defensive_code',
        title: `No defensive code`,
        tag: 'h3',
        short: `No defensive code`,
        html: [['p',
            [`No function argument validation`],
        ],
        ['pre',
            [`function send_msg(client, msg, opt){
    if (client===undefined || msg===undefined)
        throw new Error('send_msg: wrong params');
    opt = opt||{};
    msg = prepare_msg(msg);
    ...
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`function send_msg(client, msg, opt){
    opt = opt||{};
    msg = prepare_msg(msg);
    ...
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'prog_tech-assign_truth',
        title: `
  Assigning in a truth value (if or while)`,
        tag: 'h3',
        short: `Assigning in a truth value`,
        html: [['p',
            [` Assigning truth value in `,
            ['code',
                [`if`],
            ],
            ['code',
                [`while`],
            ],
            ['code',
                [`for`],
            ],
            ` helps shorten and simplify code. `],
        ],
        ['pre',
            [`for (i = 0; get_result(i); i++)
    handle_result(get_result(i));
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`for (i = 0;; i++)
{
    result = get_result(i);
    if (!result)
        break;
    handle_result(result);
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`for (i = 0; result = get_result(i); i++)
    handle_result(result);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (compute_num())
    return compute_num();
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (x = compute_num())
    return x;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`while (1)
{
    i = input();
    if (!i)
        break;
    handle_input(i);
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`while (i = input())
    handle_input(i);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'prog_tech-diable_test',
        title: `
  Temporary disabling a test`,
        tag: 'h3',
        short: `Temporary disable test`,
        html: [['p',
            [` When temporary disabling test code that fail:`,
            ['br'],
            ` Do not indent the code of the disabled tests. `],
        ],
        ['pre',
            [`if (0) // XXX yoni: fails on BAT
    jtest_eq(...);
if (0) // XXX derry: need fix for Ubuntu
{
    jtest1();
    jtest2();
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (0) // XXX yoni: fails on BAT
jtest_eq(...);
if (0){ // XXX derry: need fix for Ubuntu
jtest1();
jtest2();
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`If it is only one test (one statement), then don't use `,
            ['code',
                [`{ }`],
            ],
            ` even if the statement is written in 2 lines:`],
        ],
        ['pre',
            [`if (0) // XXX: yoni: fails on BAT
{
jtest_run(xxx, yyy,
    zzz);
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (0) // XXX: yoni: fails on BAT
jtest_run(xxx, yyy,
    zzz);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Open '{' on the same if() line:`],
        ],
        ['pre',
            [`// XXX: yoni: fails on BAT
if (0)
{
jtest_run(xxx, yyy, zzz);
jtest_run(xxx, yyy, zzz);
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`if (0){ // XXX: yoni: fails on BAT
jtest_run(xxx, yyy, zzz);
jtest_run(xxx, yyy, zzz);
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'prog_tech-perf',
        title: `Performance`,
        tag: 'h3',
        short: `Performance`,
        html: [['p',
            [` 99% of the code is not performance critical. So always try to
                write shorter, simpler, more natural and modern code. If ES6
                gives nicer simpler constructs - we use them.`,
            ['br'],
            ` But, in the rare 1% of the code that performs tight loops, we
                deviate from 'nice simple code', and write a little longer
                code, to avoid `,
            ['a',
                [` JS VM JIT in-efficiencies`],
                {href: `http://www.incaseofstairs.com/2015/06/es6-feature-performance/`},
            ],
            `.`,
            ['br'],
            ` We normally check V8, and re-check check these issues
                periodically as newer versions of JS VM's come out. `],
        ]],
    },
    {
        id: 'prog_tech-perf-for_of',
        title: `
  for..of: 3x-20x slower`,
        tag: 'h4',
        short: `for..of`,
        html: [['pre',
            [`for (let p of patterns)
    add_pattern(p);
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`for (let i=0; i<patterns.length; i++)
    add_pattern(patterns[i]);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'prog_tech-wrong_perf',
        title: `
  Wrong performance assumptions`,
        tag: 'h3',
        short: `Wrong performance assumptions`,
        html: [['p',
            [` We list here commonly mistaken performance assumptions. They
                might have been correct in the past, but JS VMs get better
                and better - so these performance improvement assumptions
                are not longer correct. `],
        ]],
    },
    {
        id: 'prog_tech-wrong_perf-map',
        title: `
  Map is faster than Object`,
        tag: 'h4',
        short: `Map vs Object`,
        html: [['p',
            [` For keys that are plain positive numbers, Object may be faster
                due to Array optimizations in the VM. But for keys that are
                strings - Map is faster. `],
        ],
        ['pre',
            [`let cache = {};
cache[key] = value;
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`let cache = new Map();
cache.set(key, value);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'deep_fix',
        title: `Deep Fix`,
        tag: 'h3',
        html: [['div',
            [` When you (or someone else) find a coding mistake in your code:
                `,
            ['div',
                [`BAD: just fixing that specific mistake you found`],
                {className: `bad`},
            ],
            ['div',
                [`OK: fixing also all such mistakes you made in your own
                    code`],
                {className: `good`},
            ],
            ['div',
                [`GOOD: fixing all such mistakes, in the whole codebase,
                    using smart rgrep's to find them.`],
                {className: `good`},
            ],
            ['div',
                [`GREAT: if this is a common mistake people tend to repeat,
                    then once a month repeat the search to find such NEW
                    mistakes.`],
                {className: `good`},
            ],
            ['div',
                [`EXCELLENT: add a rule to zlint to auto detect and if
                    possible auto fix the mistake.`],
                {className: `good`},
            ]],
        ]],
    },
    {
        id: 'hola',
        title: `Hola specific API`,
        tag: 'h2',
        short: `Hola specific API`,
        html: [],
    },
    {
        id: 'hola-disable-feature',
        title: `Disable feature`,
        tag: 'h3',
        short: `Disable feature`,
        html: [['li',
            [`dynamic using reconf: preferred`],
        ],
        ['li',
            [`env: usually when needed in init, for example port numbers`],
        ],
        ['li',
            [`if (0): unittests and non production code`],
        ],
        ['p',
            [`TBA: code examples`],
        ]],
    },
    {
        id: 'hola-etask',
        title: `etask`,
        tag: 'h3',
        short: `etask`,
        html: [],
    },
    {
        id: 'hola-etask-overview',
        title: `Overview`,
        tag: 'h4',
        short: `Overview`,
        html: [['p',
            [['code',
                [`etask`],
            ],
            ` is Hola's library for writing asynchronous code in a concise
                synchronous like manner. `],
        ]],
    },
    {
        id: 'hola-etask-why-etask',
        title: `Why etask?`,
        tag: 'h4',
        short: `Why etask?`,
        html: [['p',
            [` Promises/async functions don't support structured cancelation,
                and callbacks are difficult to coordinate/compose.`,
            ['br'],
            ['code',
                [`etask`],
            ],
            ` supports cancelation by default and can manage callback and
                promise driven subtasks easily.`,
            ['br'],
            ` For example, if we wanted to find a specific user from the DB,
                the simplest synchronous code would look like this: `],
        ],
        ['pre',
            [`function user_find_sync(){
    let conn = mongodb.connect();
    let iter = mongodb.find(conn.users, {});
    let u;
    while ((u = mongodb.get_next(iter)))
    {
        if (correct_user(u))
            break;
    }
    mongodb.close(conn);
    return u && u.username;
}
`],
            {className: `cm-s-default code  `,
                cat: ``},
        ],
        ['p',
            [` But this is synchronous, blocking code. JavaScript is async
                and single threaded, so blocking calls are a huge
                performance problem.`,
            ['br'],
            ` So lets see how to port the sync code to async code. Lets
                start with the ideal solution, using Hola's `,
            ['code',
                [`etask`],
            ],
            `s and ES6 generators. `],
        ],
        ['p',
            [`etask ES6 (perfect!):`],
        ],
        ['pre',
            [`let user_find_es6 = ()=>etask(function*(){
    let conn = yield mongodb.connect();
    let iter = yield mongodb.find(conn.users, {});
    let u;
    while (u = yield mongodb.find_next(iter))
    {
        if (yield correct_user(u))
            break;
    }
    yield mongodb.close(conn);
    return u && u.username;
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Compare this with other possible approaches:`],
        ],
        ['p',
            [`callbacks (`,
            ['a',
                [`callback-hell...`],
                {href: `http://callbackhell.com/`},
            ],
            `):`],
        ],
        ['pre',
            [`let conn, iter;
function user_find_cbs(cb){
    mongodb.connect(mongo_connected_cb, cb);
}

function mongo_connected_cb(cb){
    mongodb.find(conn.users, {}, users_find_cb, cb);
}

function users_find_cb(iter, cb){
    mongodb.get_next(iter, filter_users_cb);
}

function filter_users_cb(u, cb){
    if (!u)
        return mongo_disconnect(cb);
    correct_user(correct_user_cb, u, cb);
}

function correct_user_cb(u, is_correct, cb){
    if (is_correct)
        return mongo_disconnect(cb, u.username);
    mongo_connected_cb(cb);
}

function mongo_disconnect(cb, username){
    mongodb.close(conn, disconnected_cb, cb, username);
}

function disconnected_cb(cb, username){
    cb(username);
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`promise (includes ugly recursion to emulate a loop, nested `,
            ['code',
                [`then`],
            ],
            `, and obscure execution flow):`],
        ],
        ['pre',
            [`function user_find(){
    return mongodb.connect()
    .then(function(conn){ return mongodb.find(conn.users, {}); })
    .then(function filter(){
         return mongodb.find_next(iter).then(function(u){
            if (!u)
            {
                return mongodb.close(conn)
                .then(function(){ return cb(); });
            }
            return correct_user(u).then(function(is_correct){
                if (is_correct)
                {
                    return mongodb.close(conn).then(function(){
                        user_find_end(user.username); });
                }
                return filter(iter);
            });
        });
    });
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [['code',
                [`async function`],
            ],
            ` (no support for cancelation if the parent function exits
                early):`],
        ],
        ['pre',
            [`async function user_find(){
      let conn = await mongodb.connect();
      let iter = await mongodb.find(conn.users, {});
      let u;
      while (u = await mongodb.find_next(iter))
      {
          if (await correct_user(u))
              break;
      }
      await mongodb.close(conn);
      return u && u.username;
  }
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`etask ES5 (when generators are not available):`],
        ],
        ['pre',
            [`function user_find(){
    return etask([function(){
        return mongodb.connect();
    }, function(conn){
        return mongodb.find(conn.users, {});
    }, function(iter){
        return etask.while([function(){
            return mongodb.find_next(iter);
        }, function(u){
            if (!u)
                return this.break();
            return correct_user(u);
        }, function(is_correct){
            if (is_correct)
                this.break(u.username);
        }]);
    }, function(u){
        username = u;
        return mongodb.close(conn);
    }, function(){
        return username;
    }]);
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'hola-etask-cheat_sheet',
        title: `Cheat sheet`,
        tag: 'h4',
        short: `Cheat sheet`,
        html: [['table',
            [['tbody',
                [['tr',
                    [['td',
                        [`synchronous`],
                    ],
                    ['td',
                        [`etask ES5`],
                    ],
                    ['td',
                        [`etask ES6`],
                    ]],
                ],
                ['tr',
                    [['td',
                        [['code',
                            [`for`],
                        ]],
                    ],
                    ['td',
                        [['code',
                            [`this.for()`],
                        ]],
                    ],
                    ['td',
                        [['code',
                            [`for`],
                        ]],
                    ]],
                ],
                ['tr',
                    [['td',
                        [['code',
                            [`continue`],
                        ]],
                    ],
                    ['td',
                        [['code',
                            [`this.continue()`],
                        ]],
                    ],
                    ['td',
                        [['code',
                            [`continue`],
                        ]],
                    ]],
                ],
                ['tr',
                    [['td',
                        [['code',
                            [`return`],
                        ]],
                    ],
                    ['td',
                        [['code',
                            [`this.return()`],
                        ]],
                    ],
                    ['td',
                        [['code',
                            [`return`],
                        ]],
                    ]],
                ]],
            ]],
        ]],
    },
    {
        id: 'hola-etask-usage',
        title: `Usage examples`,
        tag: 'h4',
        html: [['p',
            [`Simple calls to etask or promise returning functions:`],
        ],
        ['pre',
            [`let process_items = ()=>etask(function*(){
    let items = yield get_items();
    for (let item of items)
    {
        if (!(yield item_valid(item))
            return false;
    }
    return true;
});
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Call a callback driven function:`],
        ],
        ['pre',
            [`let make_request = url=>etask(function*(){
    return yield etask.nfn_apply(request, [url]);
});
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Wait on an event emitter:`],
        ],
        ['pre',
            [`let save_request = (req, file)=>etask(function*(){
    req.pipe(file)
    .on('end', ()=>this.continue())
    .on('error', e=>this.throw(e));
    return yield this.wait();
});
`],
            {className: `cm-s-default code ok  has-popover`,
                cat: `ok`,
                'data-content': `OK`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`let save_request = (req, file)=>etask(function*(){
    req.pipe(file)
    .on('end', this.continue_fn())
    .on('error', this.throw_fn());
    return yield this.wait();
});
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Scheduled resource cleanup (like Go's `,
            ['code',
                [`defer`],
            ],
            ` statement):`],
        ],
        ['pre',
            [`let do_something = ()=>etask(function*(){
    let temp_dir = yield make_temp_dir();
    // temp dir will be cleaned up whether the function succeeds or throws
    this.finally(()=>unlink(temp_dir));
    yield do_step1();
    yield do_step2();
    return yield do_step3();
});
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'hola-etask-coding',
        title: `Coding`,
        tag: 'h4',
        short: `Coding`,
        html: [['p',
            [`When possible, use ES6 arrow function with no brackets and no `,
            ['code',
                [`return`],
            ]],
        ],
        ['pre',
            [`let t = function(fn, domain, expected){
    let i = 7;
    return etask(function*(){
        ...
    };
});
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`let t = (fn, domain, expected)=>etask(function*(){
    let i = 7;
    ...
});
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [['code',
                [`return etask()`],
            ],
            ` in the middle of a function should be indented to the function
                level. Should be used rarely, only when fast path needed `],
        ],
        ['pre',
            [`let get_headers = req=>{
    let cache;
    if (cache = cache_getreq)
        return cache;
    return etask(function*get_headers(){
        ...
}); }
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`let get_headers = req=>{
    let cache;
    if (cache = cache_get(req))
        return cache;
return etask(function*get_headers(){
    ...
}); }
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`etask class indentation`],
        ],
        ['pre',
            [`class Read_client {
search(q){
    let _this = this;
return etask(function*(){
    ...
}); }
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`class Read_client {
    search(q){
        let _this = this;
        return etask(function*(){
            ...
        });
    }
}
`],
            {className: `cm-s-default code ok  has-popover`,
                cat: `ok`,
                'data-content': `OK`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`class Read_client {
    search(q){
        let _this = this;
    return etask(function*(){
        ...
    }); }
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`class Read_client {
    search(q){ let _this = this; return etask(function*(){
        ...
    }); }
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`No hidden (automatic) `,
            ['code',
                [`yield`],
            ],
            ` in return.`],
        ],
        ['pre',
            [`let insert_cid_to_mongo = cid=>etask(function*(){
    let client = yield mongodb.findOne(...cid...);
    return mongodb.update(...client...);
});
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`let insert_cid_to_mongo = cid=>etask(function*(){
    let client = yield mongodb.findOne(...cid...);
    return yield mongodb.update(...client...);
});
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`etask name for lib API`],
        ],
        ['pre',
            [`E.find_all = (zmongo, selector, opt)=>etask(function*(){
    ...
});
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`E.find_all = (zmongo, selector, opt)=>etask(function*mongo_find_all(){
    ...
});
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`No etask name for internal functions`],
        ],
        ['pre',
            [`let generate_daily = user=>etask(function*generate_daily(){
    ...
});
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`let generate_daily = user=>etask(function*(){
    ...
});
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [` Avoid enclosing a large portion of a function in a try block.`,
            ['br'],
            ` Prefer this.on('uncaught', ...) and this.finally when
                applicable. (`,
            ['a',
                [`why?`],
                {className: `why`,
                    'data-why-popup': ``,
                    popup: `why_no_try_catch`},
            ],
            `) `],
        ],
        ['div',
            [` Code is shorter and the indentation reduce readability. `],
            {id: `why_no_try_catch`,
                className: `why_popup`},
        ],
        ['pre',
            [`let get_zone_bw = config=>(req, res)=>etask(function*(){
    let zone = yield check_zone(config, req, res);
    try {
        let data = yield get_graphite_bw(req, zone.customer, [zone.name]);
        res.json(data);
    } catch(e){
        zerr(zerr.e2s(e));
        return void res.status(500).send('err');
    }
});
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`let get_zone_bw = config=>(req, res)=>etask(function*(){
    let zone = yield check_zone(config, req, res);
    this.on('uncaught', err_handler(res));
    let data = yield get_graphite_bw(req, zone.customer, [zone.name]);
    res.json(data);
});
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'hola-react',
        title: `React code`,
        tag: 'h3',
        short: `React code`,
        html: [['p',
            [` Read `,
            ['a',
                [`React docs`],
                {href: `https://reactjs.org/docs/getting-started.html`},
            ],
            ` and follow guidlines and recommendations unless they conflict
                with Hola React conventions. `],
        ]],
    },
    {
        id: 'hola-react-dry',
        title: `Use Components to stay DRY`,
        tag: 'h4',
        html: [['p',
            [` Use the same guidlines for code repetition as regular
                functions: `,
            ['a',
                [`Try not repeat yourself`],
                {href: `http://hola.org/dna/tree_code#lift-tdry`},
            ],
            `. `],
        ],
        ['p',
            [`Move shared JSX to a util component to repeat markup`],
        ],
        ['pre',
            [`<div className="feature">
  <h3>title1</h3>
  <p>text</p>
</div>
<div className="feature">
  <h3>title2</h3>
  <p>text2</p>
</div>
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`let Feature = props=>
    <div className="feature">
      <h3>{props.title}</h3>
      <p>{props.children}</p>
    </div>;
<Feature title="title1">text1</Feature>
<Feature title="title2">text2</Feature>
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'hola-react-jsx',
        title: `JSX`,
        tag: 'h4',
        html: [['p',
            [` JSX coding convention follows `,
            ['a',
                [`HTML coding`],
                {href: `/dna/html_code`},
            ],
            `. When switching from JS code to JSX code use 4 chars
                indentation on the first. Rest follow HTML convention of 2
                chars indentation. `],
        ],
        ['pre',
            [`return <View>
  </View>;
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`return <View></View>;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`return <View>
    </View>;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`return <View>
      <Button/>
    </View>;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`return (
    <View>
      <Button/>
    </View>);
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`return (
    <View>
      <Button/>
    </View>
);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`return (
    <View>
      {show_panel &&
          <Panel/>}
    </View>)
);
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`return (
    <View>
      {show_panel &&
        <Panel/>}
    </View>
);
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'hola-react-css',
        title: `CSS`,
        tag: 'h4',
        html: [['p',
            [`Use `,
            ['a',
                [`CSS conventions for react`],
                {href: `/dna/css_code#react`},
            ]],
        ]],
    },
    {
        id: 'hola-unittest',
        title: `Unittest`,
        tag: 'h3',
        short: `unittest`,
        html: [['p',
            [`TBD`],
        ]],
    },
];
return E;
});
